export default __webpack_public_path__ + "static/media/kadra_asia.ca4e3ea6.jpeg";